"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./EphemeralBanner.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ContentItem = _interopRequireDefault(require("../cms/ContentItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EphemeralBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(EphemeralBanner, _React$Component);

  var _super = _createSuper(EphemeralBanner);

  function EphemeralBanner() {
    _classCallCheck(this, EphemeralBanner);

    return _super.apply(this, arguments);
  }

  _createClass(EphemeralBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ctaLink = _this$props.ctaLink,
          ctaText = _this$props.ctaText,
          bannerHeaderContentKey = _this$props.bannerHeaderContentKey,
          bannerMessageContentKey = _this$props.bannerMessageContentKey,
          ctaOpenInNewTab = _this$props.ctaOpenInNewTab,
          ctaVisible = _this$props.ctaVisible;
      return /*#__PURE__*/_react.default.createElement("section", {
        className: "ephemeral-banner"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ephemeral-banner-content-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ephemeral-banner-text-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        className: "ephemeral-banner-header",
        contentKey: bannerHeaderContentKey
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        className: "ephemeral-banner-text",
        contentKey: bannerMessageContentKey
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cta-button-container"
      }, ctaVisible && /*#__PURE__*/_react.default.createElement("a", {
        className: "ctaButton",
        target: ctaOpenInNewTab ? "_blank" : "_self",
        href: ctaLink
      }, ctaText))));
    }
  }]);

  return EphemeralBanner;
}(_react.default.Component);

exports.default = EphemeralBanner;

_defineProperty(EphemeralBanner, "propTypes", {
  ctaLink: _propTypes.default.string,
  ctaText: _propTypes.default.string,
  bannerHeader: _propTypes.default.string,
  bannerText: _propTypes.default.string,
  ctaOpenInNewTab: _propTypes.default.bool,
  ctaVisible: _propTypes.default.bool
});